export enum NomesCartoesViabilidadeEnum {
  DadosGerais = 0,
  Loteadora = 1,
  DadosCompraTerreno = 2,
  Infraestrutura = 3,
  Comercial = 4,
  Construcao = 5,
  Urbanizacao = 6,
  DetalhamentoProjeto = 7
}
